import {useState, useEffect, useRef} from 'react';

const calculateCurrentProgress = (from, to) => {
    const difference = to - from,
          progress = (Date.now() - from) / difference;

    return progress;
}

export default ({progress_key, from, to}) => {
    const [value, setValue] = useState(calculateCurrentProgress(from, to)),
          svg_progress = useRef();

    const setProgress = (progress) => {
        if (!svg_progress.current) return;
        const p = Math.max(0, Math.min(1, progress)) * 100;
        svg_progress.current.setAttribute("stroke-dasharray", `${p} 100`);
    };

    useEffect(() => {
        setProgress(value);

        if(typeof window.svgProgressTimeouts === 'undefined')
            window.svgProgressTimeouts = {};

        window.svgProgressTimeouts[progress_key] = setTimeout(() => {
            setValue(calculateCurrentProgress(from, to));
        }, 500);

        return () => clearTimeout(window.svgProgressTimeouts[progress_key]);
    }, [value]);


    return (
        <svg
        width="426"
        height="231"
        viewBox="-9 -9 444 231"
        xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M 0 213 A 213 213 0 0 1 426 213"
                fill="none"
                stroke="rgba(255,255,255,0.25)"
                stroke-width="18"
                stroke-linecap="round"
                pathLength="100"
            />


            <path
                ref={svg_progress}
                d="M 0 213 A 213 213 0 0 1 426 213"
                fill="none"
                stroke="#ffffff"
                stroke-width="18"
                stroke-linecap="round"
                pathLength="100"
                stroke-dasharray="50 100"
            />
        </svg>
    )
}